import AllClothAssignContainer from './AllClothAssignContainer'

const AllClothAssign = () => {
  return (
    <div className='page-body'>
      <AllClothAssignContainer />
    </div>
  )
}

export default AllClothAssign